import React from 'react';
import {Link} from 'react-router-dom';
import { MenuItem } from 'ui';
import BaseProjectRow from './BaseProjectRow';
import { getProjectDisplayName } from './projectRowUtils';
import { useIsProjectOwner } from 'hooks/users/useIsProjectOwner';
import { useArchiveProject } from 'hooks/projects/mutations';
import { useIsFetching, useQueryClient } from '@tanstack/react-query';
import { projectKeys } from 'hooks/projects/queries';
import { useRemoveCollaborator } from 'hooks/users/mutations';
import { useCurrentUser } from 'hooks/users/queries';

function ActiveProjectRow(props) {
  const isOwner = useIsProjectOwner(props.project);
  const archiveMutation = useArchiveProject();
  const isFetchingProjects = useIsFetching({ queryKey: projectKeys.all });
  const removeCollaboratorMutation = useRemoveCollaborator();
  const { data: currentUser } = useCurrentUser();
  const queryClient = useQueryClient();
  
  if (!props.project || !props.project.id) return <div></div>;

  const displayName = getProjectDisplayName(props.project.name);
  const isArchiving = archiveMutation.isPending || (archiveMutation.isSuccess && isFetchingProjects > 0);
  const isLeaving = removeCollaboratorMutation.isPending || (removeCollaboratorMutation.isSuccess && isFetchingProjects > 0);
  
  const archiveProject = (e, projectId) => {
    e.preventDefault();
    archiveMutation.mutate(projectId, {
      onError: () => {
        props.errorArchivingProject(true);
      }
    });
  };
  
  const leaveProject = (e, projectId) => {
    e.preventDefault();
    if (currentUser && currentUser.id) {
      removeCollaboratorMutation.mutate(
        { 
          projectId: projectId, 
          collaboratorId: currentUser.id 
        },
        {
          onSuccess: () => {
            // Invalidate projects query to refresh the project list
            queryClient.invalidateQueries({ queryKey: projectKeys.all });
          }
        }
      );
    }
  };
  
  // Custom project name with link
  const projectNameContent = (
    <Link to={`/projects/${props.project.id}`} onClick={props.onHide}>
      {displayName}
    </Link>
  );

  // Menu items specific to active projects
  const menuItems = (
    <>
      {
        props.subscriptionStateLoaded &&
        <MenuItem
          eventKey="0"
          onClick={()=>props.duplicateProject(props.project.id)}
        >
          Copy Codes Into New Project
        </MenuItem>
      }
      {!isOwner &&
        <MenuItem
          eventKey="2"
          onClick={(e)=>leaveProject(e, props.project.id)}
          disabled={isLeaving}
        >
          {isLeaving ? 'Leaving...' : 'Leave Project'}
        </MenuItem>
      }
      {isOwner && 
        <MenuItem
          eventKey="2"
          onClick={(e)=>archiveProject(e, props.project.id)}
          disabled={isArchiving}
        >
          {isArchiving ? 'Archiving...' : 'Archive Project'}
        </MenuItem>
      }
    </>
  );

  return (
    <BaseProjectRow
      project={props.project}
      onHide={props.onHide}
      projectNameContent={projectNameContent}
      menuItems={menuItems}
    />
  );
}

export default ActiveProjectRow;